export default __webpack_public_path__ + "static/media/cfa.00567f7a.png";